import { GraphQLError } from 'graphql';

const messageMappings = [
  [/unexpected execution error/i, 'A001'],
  [/failed to fetch/i, 'A101'],
  [/cannot return null for non-nullable field/i, 'A201'],
  [/forecast is invalid/i, 'A202'],
  [/unexpected end of (?:json|data)|expected property name or .* json/i, 'A203'],
  [/received status code 504/i, 'A301'],
  [/the request exceeded the (?:configured |)timeout/i, 'A302'],
  [/redirect to login/i, 'A401'],
  [/the provided authorization grant/i, 'A402'],
  [/forbidden resource/i, 'A403'],
  [/the current user is not authorized/i, 'A404'],
  [/user .* is not authorized to access/i, 'A405'],
  [/xhr aborted/i, 'A406'],
  [/the current sales partner has no sites or power plants assigned./i, 'A407'],
  [/authoriz|forbidden/i, 'A400'],
  [/scheduling api request failed/i, 'A501'],
  [/detail/i, 'A502'],
  [/copt api not responding/i, 'A503'],
  [/Day-Ahead Schedules must not contain chronological gaps/i, 'A504'],
] as const;

/**
 * Returns an error code that is suitable for display to the user.
 *
 * @param error
 * @see https://confluence.energy2market.de/display/ITS/Fehlercodes+im+Kundenportal
 */
export function getErrorCode(error: string | Error | undefined): string {
  if (error) {
    const message = typeof error === 'string' ? error : error.message;
    for (const [reg, code] of messageMappings) {
      if (reg.test(message)) {
        return code;
      }
    }

    if (error instanceof GraphQLError) {
      return 'A200';
    }
  }

  return 'A000';
}

export enum userIds {
  UnknownRole = 0,
  PlantOperator = 1,
  VPPOperator = 2,
  External = 3,
  CuPoOperator = 4,
  SalesPartner = 5,
  BasicUser = 6,
}
